module.exports = __webpack_public_path__ + "static/media/weekly_wins_placeholder.4930379d.svg";